import React from "react";
import { Button, Card } from "react-bootstrap";
import { Private_Routes } from "../../../../constants";
import { useNavigate } from "react-router-dom";

interface ErrorCardProps {
  message?: string;
  onBack?: () => void;
}

const DEFAULT_TITLE = "No pudimos cargar la programacion";
const DEFAULT_DESCRIPTION =
  "Ocurrio un error al cargar la informacion. Puedes volver al inicio e intentarlo nuevamente.";

export const ErrorCard = ({ message, onBack }: ErrorCardProps) => {
  const navigation = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
      return;
    }

    navigation(`/${Private_Routes.HOME}`);
  };

  return (
    <Card>
      <Card.Body className="text-center py-5">
        <div className="mb-3">
          <i
            className="mdi mdi-alert-circle-outline"
            style={{ fontSize: 42, color: "#DC2626" }}
          />
        </div>
        <h5 className="mb-2">{DEFAULT_TITLE}</h5>
        <p className="text-muted mb-4">{message?.trim() || DEFAULT_DESCRIPTION}</p>
        <Button variant="primary" onClick={handleBack}>
          Volver
        </Button>
      </Card.Body>
    </Card>
  );
};
